import {
  Box,
  Heading,
  Text,
  UnorderedList,
  ListItem,
  VStack,
} from '@chakra-ui/react';

export const SubprocessorsPage = () => {
  return (
    <Box
      bg="white"
      color="gray.800"
      maxW="756px"
      mx="auto"
      px={6}
      pt={16}
      pb={24}
      fontFamily="marketingPage"
      fontSize="15px"
      lineHeight="24px">
      <VStack align="start" spacing={12}>
        <Box>
          <Heading as="h1" fontSize="40px" mb={4} fontFamily="marketingPage">
            Subprocessors
          </Heading>
          <Text fontSize="sm" color="gray.600">
            Last updated: November 2025
          </Text>
          <Text mt={4}>
            Merkatus.io engages the following trusted service providers as
            subprocessors to support delivery of the Merkatus platform. Each
            subprocessor is vetted for security and privacy compliance prior to
            onboarding.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" fontSize="24px" mb={4} fontFamily="marketingPage">
            Current Subprocessors
          </Heading>
          <UnorderedList pl={4} spacing={2}>
            <ListItem>Amazon Web Services, Inc.</ListItem>
            <ListItem>Amplitude, Inc.</ListItem>
            <ListItem>Sentry (Functional Software, Inc.)</ListItem>
          </UnorderedList>
        </Box>
      </VStack>
    </Box>
  );
};
